var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"common-button",class:{ 'button-loading': _vm.isLoading, 'disable-btn': _vm.isDisabled },attrs:{"type":_vm.type,"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('b-spinner',{attrs:{"label":"Spinning","small":""}})],1):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }